import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#notification" }),
    /*#__PURE__*/_createTextVNode(" Notification ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Displays a global notification message at a corner of the page. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUIWithTypes = _resolveComponent("EUIWithTypes")
  const _component_EUICustomPosition = _resolveComponent("EUICustomPosition")
  const _component_EUIWithOffset = _resolveComponent("EUIWithOffset")
  const _component_EUIUseHTMLString = _resolveComponent("EUIUseHTMLString")
  const _component_EUIHideCloseButton = _resolveComponent("EUIHideCloseButton")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUIWithTypes),
    _createVNode(_component_EUICustomPosition),
    _createVNode(_component_EUIWithOffset),
    _createVNode(_component_EUIUseHTMLString),
    _createVNode(_component_EUIHideCloseButton)
  ], 64))
}